define( [ 'jquery', 'utility' ], function( $, util ) {
	'use strict';

	var segmented = {

		init : function( el ) {
			var $wrapper = $( el );

			if ( !$wrapper.hasClass( 'js-segmented' ) ) {
				$wrapper.addClass( 'm-radio-group--segmented js-segmented' );

				var that = this;

				$wrapper.breakpoint = util.getBreakpoint();
				$wrapper.$radio_group_items = $wrapper.find( '.m-radio-group__item' );

				$wrapper.append( '<li class="m-radio-group__ui"></li>' );
				$wrapper.$slider_ui = $wrapper.find( '.m-radio-group__ui' );

				$wrapper.find( '.a-radio__input' ).on( 'change', function() {
					that.updateChecked( $wrapper );
				})
					.on( 'focus', function() {
						$wrapper.addClass( 'has-focus' );
					})
					.on( 'blur', function() {
						$wrapper.removeClass( 'has-focus' );
					});

				$wrapper.$window = $( window );
				$wrapper.window_width = $wrapper.$window.width();

				var onResize = util.debounce( function() {
						var new_window_width = $wrapper.$window.width();
						if ( new_window_width !== $wrapper.window_width ) {
							$wrapper.window_width = new_window_width;
							$wrapper.breakpoint = util.getBreakpoint();
							$wrapper.$slider_ui.css( 'transition', 'none' );
							that.shortLabel( $wrapper );
							that.positionSlider( $wrapper );
						}
					}, 10 ),
					onRefresh = util.debounce( function() {
						if ( $wrapper.is( ':visible' ) ) {
							$wrapper.$slider_ui.css( 'transition', 'none' );
							that.shortLabel( $wrapper );
							that.positionSlider( $wrapper );
						}
					}, 10 );
				$wrapper.$window.on( 'resize', onResize )
					.on( 'refresh', onRefresh );

				that.shortLabel( $wrapper );
				that.updateChecked( $wrapper );
			}
		},

		updateChecked : function( $wrapper ) {
			$wrapper.$radio_group_items.removeClass( 'is-checked' );
			$wrapper.$checked = $wrapper.find( '.a-radio__input:checked' ).parents( '.m-radio-group__item' )
				.addClass( 'is-checked' );

			if ( $wrapper.$checked.length > 0 ) {
				$wrapper.removeClass( 'js-radio-checked js-radio-checked--1 js-radio-checked--2 js-radio-checked--3 js-radio-checked--4 js-radio-checked--5' ).addClass( 'js-radio-checked js-radio-checked--' + ( $wrapper.$checked.index() + 1 ) );
			}

			this.positionSlider( $wrapper );
		},

		positionSlider : function( $wrapper ) {
			if ( $wrapper.breakpoint === util.smallTag && !$wrapper.hasClass( 'm-radio-group--short-label' ) && $wrapper.$checked.length > 0 ) {
				setTimeout( function() {
					$wrapper.$slider_ui.removeAttr( 'style' );
					$wrapper.$slider_ui.css({
						'height' : $wrapper.$checked.outerHeight(),
						'top' : $wrapper.$checked.position().top
					});
				}, 50 );
			} else {
				setTimeout( function() {
					$wrapper.$slider_ui.removeAttr( 'style' );
				}, 50 );
			}
		},

		shortLabel : function( $wrapper ) {
			if ( !$wrapper.hasClass( 'm-radio-group--pictorial' ) ) {
				$wrapper.each( function() {
					var $shortLabel = $( this );
					$shortLabel.removeClass( 'm-radio-group--short-label' );

					var $temp_span = $( '<span class="short-label-span">' + $shortLabel.text() + '</span>' );
					$shortLabel.append( $temp_span );

					var text_width = $temp_span.width() + 60,
						wrapper_width = $shortLabel.width();

					if ( $wrapper.hasClass( 'm-radio-group--2' ) && text_width < wrapper_width - 60 ) {
						$shortLabel.addClass( 'm-radio-group--short-label' );
					} else if ( $wrapper.hasClass( 'm-radio-group--3' ) && text_width < wrapper_width - 90 ) {
						$shortLabel.addClass( 'm-radio-group--short-label' );
					} else if ( $wrapper.hasClass( 'm-radio-group--4' ) && text_width < wrapper_width - 120 ) {
						$shortLabel.addClass( 'm-radio-group--short-label' );
					} else if ( $wrapper.hasClass( 'm-radio-group--5' ) && text_width < wrapper_width - 150 ) {
						$shortLabel.addClass( 'm-radio-group--short-label' );
					} else {
						$shortLabel.removeClass( 'm-radio-group--short-label' );
					}
					$temp_span.remove();
				});
			}
		}
	};

	return {
		initInstance : function( el ) {
			segmented.init( el );
		}
	};
});
